/* eslint-disable import/order */
import { whenDomReady } from "@allwyn/utils/document-ready";
import { mountSharedVueRoots } from "./shared/setup/mount-vue-roots";
import { useGdpr } from "@allwyn/gdpr/composables/use-gdpr";
import { initWecomaMock } from "@allwyn/gdpr/wecoma-mock";
import "@allwyn/shared-components/layout/footer/_breadcrumbs";
import { useChat } from "@allwyn/shared-components/layout/fixed-help/composables/use-chat";
import { useFooter } from "@allwyn/shared-components/layout/footer/footer";
import { useHeaderStack } from "@allwyn/shared-components/layout/header-stack/header-stack";
import { useGlobalVideoModal } from "@allwyn/design-system/src/modal-video/mount-modal-video";
import { IconAssets } from "@sazka/design-system/src/icon/icon-assets";
import { useAppInsights } from "@sazka/utils/logger/app-insights";
import { useNgLib } from "@/integrations/aristocrat-ng/ng-lib";
import { useAuthentication } from "@sazka/ng/authentication/composables/use-authentication";
import { initSelfExclusionButton } from "@allwyn/ng/panic-button/core/self-exclusion";
import { useExponea } from "./integrations/exponea/use-exponea";
import { useChatIntegration } from "./integrations/chat/use-chat-integration";
IconAssets.configure("/assets/icons");

useAuthentication().initializeInterface();
useExponea().registerExponeaToWindow();
useChatIntegration().setupAll();

await whenDomReady();

useAppInsights().trackMetric("DOCUMENT_READY", performance.now());
useChat().registerChatToWindow();
initWecomaMock();
mountSharedVueRoots();
useHeaderStack();
useFooter();
useGlobalVideoModal();
useGdpr().init();

let ngLoadingPromise: Promise<void> | null = null;

if (window.environment.channelName !== "hraj-s-rozumem") {
    initSelfExclusionButton();
    ngLoadingPromise = useNgLib();
}

useAppInsights().trackMetric("SCRIPT_EVALUATION", performance.now());

if (ngLoadingPromise !== null) {
    await ngLoadingPromise;
    useAppInsights().trackMetric("NG_Loading_Time", performance.now());
}
